<template>
  <div class="trade-table">
    <div class="change-type">
      <button @click="myTrade = true ; trade = false"
              :class="{'gray-btn' : myTrade === true , 'solid-gray-btn' : myTrade === false }" >
        معاملات من
      </button>
      <button @click="myTrade = false ; trade = true"
              :class="{'gray-btn' : trade === true , 'solid-gray-btn' : trade === false }">
        معاملات بازار
      </button>
    </div>
    <div class="table">
      <table>
        <tr class="sticky">
          <th class="right-text">قیمت</th>
          <th class="center-text">مقدار</th>
          <th class="left-text">زمان</th>
        </tr>

        <tr v-for="(item , index) in coins" :key="index">
          <td class="number right-td" :class="{'red' : item.price < 0 ,'green' : item.price > 0}">{{ item.price }}</td>
          <td class="number center-td">{{ item.value }}</td>
          <td class="left-td">{{ item.date }}</td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "trade-table",

  data() {
    return {
      myTrade:false,
      trade:true,
      coins: [
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
        {price: -123456789, value: 0.0001, date: '13:45:15'},
        {price: 123456789, value: 0.0001, date: '13:45:15'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.trade-table {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 387px;

  .change-type {
    display: flex;
    justify-content: center;
    gap: 10px;

    button {
      width: 163px !important;
      height: 25px;
    }
  }

  .table {
    height: 400px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .sticky{
      position: sticky;
      top: 0;
      background-color: #0B1628;

      .right-text{
        text-align: right;
        padding-right: 13px;
      }

      .center-text{
        text-align: center;
      }

      .left-text{
        text-align: left;
        padding-left: 10px;
      }
    }

    table {
      table-layout: fixed;

      .right-td{
        text-align: right;
        padding-right: 10px;
      }

      .center-td{
        text-align: center;
      }

      .left-td{
        text-align: left;
        padding-left: 10px;
      }

      th {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }

      tr {
        height: 26px;
        &:hover {
          cursor: pointer;
          background: linear-gradient(259.33deg, rgba(28, 52, 102, 0) 7.64%, rgba(28, 52, 102, 0.35) 52.12%, rgba(20, 37, 69, 0.24) 83.62%);
        }
      }

      td {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }
    }
  }
}
</style>